"use client";

import "@uiw/react-markdown-preview/markdown.css";
import "@/styles/markdown-content.css";

import { useEffect, useState } from "react";

import { ImageGallery } from "@/components/ui/image-gallery";
import { getResolvedTheme, type ThemeMode } from "@/lib/theme";

export function MarkdownBody({
  html,
  className = "",
}: {
  html: string;

  className?: string;
}) {
  const [mode, setMode] = useState<ThemeMode>("light");

  useEffect(() => {
    const update = () => setMode(getResolvedTheme());
    update();
    const observer = new MutationObserver(update);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  return (
    <ImageGallery>
      <div
        className={`wmde-markdown md-prose !bg-transparent${className ? ` ${className}` : ""}`}
        data-color-mode={mode}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </ImageGallery>
  );
}
